<script>
  // @ts-check

  import DynamicHeading from "../../atoms/DynamicHeading.svelte";
  import DynamicHeadingContext from "../../atoms/DynamicHeadingContext.svelte";

  /** Primarily used for testing
   * @type {string}
   * */
  export let id = undefined;

  /** Label - headline label
   *  @type {string}
   * */
  export let label;

  /**
   * Big number of each ListItem
   * @type {Number}
   */
  export let number = undefined;

  const marginClass = $$slots.default ? "mb-4 md:mb-5 xl:mb-7.5" : "";
  const containerClass = number ? "col-span-3" : "col-full-width";
</script>

<DynamicHeadingContext>
  <div {id} class="grid grid-cols-4 gap-x-8 md:block">
    {#if number}
      <p class="heading-xl md:mb-5 xl:mb-7.5">{number}</p>
    {/if}
    <div class="body-sm {containerClass}">
      <DynamicHeading class="heading-xs {marginClass}">
        {label}
      </DynamicHeading>
      <slot />
    </div>
  </div>
</DynamicHeadingContext>
